/* eslint-disable react-hooks/rules-of-hooks */
import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";
import { z } from "zod";

export const AddCategorySchema = z.object({
  name: z.enum(["Primary Packages", "Addons"], {
    required_error: "Please select a category type",
  }),
  description: z.string().min(3),
});

export type AddCategorySchemaType = z.infer<typeof AddCategorySchema>;

export async function addCategory(formData: AddCategorySchemaType) {
  try {
    const response = await axiosInstance.post(
      `${config.apiUrl}/categories`,
      formData
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.response?.data);
    } else {
      console.error("Unknown error:", error);
    }
    throw error;
  }
}
